import SEO from "../../components/SEO";
import React, { useEffect, useState } from "react";
import ParcelOrderService from "../../services/parcel-order.service";
import { EmptyState } from "../../components/EmptyState";
import OrderCard from "../../components/OrderCard";
import { ClockIcon, ArchiveBoxIcon } from "@heroicons/react/24/outline";

export const ParcelsPage = () => {
	const [OrdersState, setOrderState] = useState({ orders: [] });
	const { orders } = OrdersState;

	useEffect(() => {
		const fetchOrders = async () => {
			try {
				const data = await ParcelOrderService.index();
				setOrderState((prev) => ({ ...prev, orders: data }));
			} catch (error) {
				console.error("Error fetching orders:", error);
			}
		};
		fetchOrders();
	}, []);

	return (
		<div className="w-full min-h-screen flex flex-col bg-gradient-to-br from-cyan-50 to-fuchsia-100"><SEO title="My Parcels" noIndex />
			<div className="px-4 py-6 lg:px-20 lg:py-8 flex flex-col gap-8">

				{/* Page Header */}
				<div>
					<h1 className="text-2xl md:text-4xl font-extrabold text-gray-800">My Parcels</h1>
					<p className="text-gray-500 mt-1 text-sm">Track and manage all your parcel deliveries</p>
				</div>

				{/* Pending Deliveries */}
				<section className="flex flex-col gap-4">
					<div className="flex items-center gap-3">
						<div className="flex items-center gap-2 bg-amber-500 text-white px-4 py-2 rounded-xl shadow-sm">
							<ClockIcon className="w-5 h-5" />
							<h2 className="text-sm md:text-base font-bold tracking-wide">Pending Deliveries</h2>
						</div>
						{orders?.upcoming_parcels?.length > 0 && (
							<span className="bg-amber-100 text-amber-700 text-xs font-bold px-3 py-1.5 rounded-full border border-amber-200">
								{orders.upcoming_parcels.length} active
							</span>
						)}
					</div>
					<div className="flex flex-col gap-3">
						{orders?.upcoming_parcels?.length > 0
							? orders.upcoming_parcels.map((order, i) => <OrderCard key={i} order={order} />)
							: <EmptyState />}
					</div>
				</section>

				{/* Divider */}
				<div className="border-t border-gray-200" />

				{/* Past Deliveries */}
				<section className="flex flex-col gap-4">
					<div className="flex items-center gap-3">
						<div className="flex items-center gap-2 bg-gray-600 text-white px-4 py-2 rounded-xl shadow-sm">
							<ArchiveBoxIcon className="w-5 h-5" />
							<h2 className="text-sm md:text-base font-bold tracking-wide">Past Deliveries</h2>
						</div>
						{orders?.past_parcels?.length > 0 && (
							<span className="bg-gray-100 text-gray-600 text-xs font-bold px-3 py-1.5 rounded-full border border-gray-200">
								{orders.past_parcels.length} completed
							</span>
						)}
					</div>
					<div className="flex flex-col gap-3 opacity-85">
						{orders?.past_parcels?.length > 0
							? orders.past_parcels.map((order, i) => <OrderCard key={i} order={order} />)
							: <EmptyState />}
					</div>
				</section>
			</div>
		</div>
	);
};
